import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { EFormService } from '../../../../../shared-components/e-forms/e-form.service';
import { EFormRow } from '../../../../../shared-components/e-forms/e-form-row.model';
import { EFormColumn } from '../../../../../shared-components/e-forms/e-form-column.model';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { EFormPage } from '../../../../../shared-components/e-forms/e-form-page.model';
import { EFormTab } from '../../../../../shared-components/e-forms/e-form-tab.model';
import { EFormControl } from '../../../../../shared-components/e-forms/e-form-control.model';
import { Lookup } from '../../../../../shared-components/lookup/lookup.model';
import { MatDialog } from '@angular/material/dialog';
import { MergeFieldDialogComponent } from '../../merge-field-dialog/merge-field-dialog.component';
import { EFormMergeField } from '../../../../../shared-components/e-forms/e-form-merge-field.model';
import { QuillEditorComponent } from 'ngx-quill';
import { EFormChoicesDialogComponent } from '../../e-form-choices-dialog/e-form-choices-dialog.component';
import { ValueFromAnotherFieldDialogComponent } from '../../value-from-another-field-dialog/value-from-another-field-dialog.component';
import { EFormDatabaseField } from '../../../../../shared-components/e-forms/e-form-database-field.model';
import { YearService } from '../../../../../shared-components/year/year.service';
import { LookupService } from '../../../../../shared-components/lookup/lookup.service';
import { EFormAttachment } from '../../../../../shared-components/e-forms/e-form-attachment.model';
import { LoginService } from '../../../../../shared-modules/login/login.service';
import { EFormDesignerService } from '../../e-form-designer.service';
import { CSTField } from '../../../../../shared-modules/customization-framework/models/custom-data-field.model';
import { EFormConfiguration, enmEFormViewModes } from '../../../e-form-config.model';
import { CustomFieldControlTypeEnum } from '../../../../../shared-modules/customization-framework/models/custom-data-control-type.model';
import { CustomizationFrameworkService } from '../../../../../shared-modules/customization-framework/customization-framework.service';
import { enmCustomDataObjects } from '../../../../../shared-modules/customization-framework/models/custom-data-object.model';
import { take } from 'rxjs/operators';
import { CustomFieldDataTypeEnum } from '../../../../../shared-modules/customization-framework/models/custom-data-field-type.model';
import { DataDefinitionList } from '../../../../../admin360/data-definition/data-definition.model';

@AutoUnsubscribe({ includeArrays: true })
@Component({
  selector: 'e-form-properties-panel',
  templateUrl: './e-form-properties-panel.component.html',
  styleUrls: ['./e-form-properties-panel.component.css']
})
export class EFormPropertiesPanelComponent implements OnInit, OnDestroy {

  selectedTab: EFormTab;
  selectedPage: EFormPage;
  selectedColumn: EFormColumn;
  selectedRow: EFormRow;
  selectedControl: EFormControl;
  selectedElementType: string;
  promptForDataObjects: EFormControl[] = [];
  conditions: Lookup[] = [];
  allDBFields: EFormDatabaseField[] = [];
  databaseFields: EFormDatabaseField[] = [];
  showChoicesLink = false;
  cursorPosition: 0;
  studentPortfolioCategories: Lookup[] = [];
  selectedStuPortCategory: Lookup;
  documentTypes: Lookup[] = [];
  selectedDocType: Lookup;
  v10 = false;
  isCodeDescriptionValue: boolean;
  availableCustomFields: CSTField[] = [];
  isDevMode = false;
  isCustomFieldsActive = false;
  @ViewChild('quillDisplayText') quill: QuillEditorComponent;
  @ViewChild('quillInstructions') quillInstructions: QuillEditorComponent;
  subscriptions: Subscription[] = [];
  @Input() config: EFormConfiguration;

  quillOptions = {
    toolbar: [
      [
        'bold',
        'italic',
        'underline',
        'strike'
      ],
      [
        'blockquote',
        'code-block'
      ],
      [
        {
          'header': 1
        },
        {
          'header': 2
        }
      ],
      [
        {
          'list': 'ordered'
        },
        {
          'list': 'bullet'
        }
      ],
      [
        {
          'script': 'sub'
        },
        {
          'script': 'super'
        }
      ],
      [
        {
          'indent': '-1'
        },
        {
          'indent': '+1'
        }
      ],
      [
        {
          'direction': 'rtl'
        }
      ],
      [
        {
          'color': []
        },
        {
          'background': []
        }
      ],
      [
        {
          'size': [
            'small',
            false,
            'large',
            'huge'
          ]
        }
      ],
      [
        {
          'header': [
            1,
            2,
            3,
            4,
            5,
            6,
            false
          ]
        }
      ],
      [
        {
          'font': []
        }
      ],
      [
        {
          'align': []
        }
      ],
      [
        'clean'
      ],
      [
        'link',
        'image',
        'video'
      ]
    ]
  };

  constructor(
    private eFormService: EFormService,
    private eFormDesignerService: EFormDesignerService,
    private dialog: MatDialog,
    private yearService: YearService,
    private lookupsService: LookupService,
    private loginService: LoginService,
    private customizationFrameworkService: CustomizationFrameworkService
  ) { }

  ngOnInit() {
    this.v10 = this.loginService.LoginSettings.V10;
    this.isCustomFieldsActive = this.loginService.LoginSettings.EnableCustomizationFramework && this.loginService.LoginSettings.C360CustomFieldsImported;
    this.isDevMode = this.loginService.LoginSettings.CustomizationDevMode;
    this.selectedTab = this.eFormDesignerService.selectedTab;
    this.selectedPage = this.eFormDesignerService.selectedPage;
    this.selectedColumn = this.eFormDesignerService.selectedColumn;
    this.selectedRow = this.eFormDesignerService.selectedRow;
    this.selectedControl = this.eFormDesignerService.selectedControl;
    this.selectedElementType = this.eFormDesignerService.selectedElementType;
    this.subscriptions.push(this.eFormDesignerService.observableselectedElementChangedStream$.subscribe(o => {
      let selectedTypeChanged = false;
      if (this.selectedElementType != this.eFormDesignerService.selectedElementType) {
        selectedTypeChanged = true;
        this.selectedElementType = this.eFormDesignerService.selectedElementType;
      }
      if (this.selectedTab != this.eFormDesignerService.selectedTab || selectedTypeChanged) {
        this.selectedTab = this.eFormDesignerService.selectedTab;
        this.tabChange();
      }
      if (this.selectedPage != this.eFormDesignerService.selectedPage || selectedTypeChanged) {
        this.selectedPage = this.eFormDesignerService.selectedPage;
        this.pageChange();
      }
      if (this.selectedColumn != this.eFormDesignerService.selectedColumn || selectedTypeChanged) {
        this.selectedColumn = this.eFormDesignerService.selectedColumn;
        if (this.selectedColumn.FixedWidth == null) {
          this.selectedColumn.FixedWidth = false;
        }
      }
      if (this.selectedRow != this.eFormDesignerService.selectedRow || selectedTypeChanged) {
        this.selectedRow = this.eFormDesignerService.selectedRow;
      }
      if (this.selectedControl != this.eFormDesignerService.selectedControl || selectedTypeChanged) {
        this.selectedControl = this.eFormDesignerService.selectedControl;
        this.controlChange();

      }
    }));

    this.subscriptions.push(this.eFormDesignerService.observableControlsUpdatedStream$.subscribe(o => {
      this.getPromptForDataObjects();
    }));

    this.subscriptions.push(this.eFormDesignerService.observableMergeFieldClickedStream$.subscribe(mergeField => {
      this.mergeFieldClicked(mergeField);
    }));
    this.getStudentPortfolioCategories();
    this.getDocumentTypes();
    this.getDatabaseFields();
  }

  getDatabaseFields() {
    if (this.isCustomFieldsActive && !this.config.CustomFieldsFlag && (this.config.ViewMode == enmEFormViewModes.Template || this.config.ViewMode == enmEFormViewModes.Instance || this.config.ViewMode == enmEFormViewModes.Form)) {
      let isStudentForm = false;
      if (this.config.ViewMode == enmEFormViewModes.Template && this.eFormService.selectedTemplate.Type == 'student') {
        isStudentForm = true;
      }
      else if (this.config.ViewMode == enmEFormViewModes.Instance && this.eFormService.selectedInstance.TemplateType == 'student') {
        isStudentForm = true;
      }
      else if (this.config.ViewMode == enmEFormViewModes.Form && this.eFormService.selectedForm.TemplateType == 'student') {
        isStudentForm = true;
      }
      if (isStudentForm) {
        // cst fields
        if (this.customizationFrameworkService.customDataFields && this.customizationFrameworkService.customDataFields.length > 0) {
          this.eFormDesignerService.availableCSTFields = this.customizationFrameworkService.customDataFields.filter(o => o.ObjectID == enmCustomDataObjects.Student);
          this.filterCSTFields();
          this.setSelectedCSTField();
        }
        else {
          this.customizationFrameworkService.getCustomDataFieldsByObjectID(enmCustomDataObjects.Student).pipe(take(1)).subscribe(fields => {
            this.eFormDesignerService.availableCSTFields = fields;
            this.filterCSTFields();
            this.setSelectedCSTField();
          });
        }
      }
    }
    else {
      this.allDBFields = this.eFormService.databaseFields;
      this.filterDatabaseFields();
      this.subscriptions.push(this.eFormService.observableDatabaseFieldsStream$.subscribe(fields => {
        this.allDBFields = fields;
        this.filterDatabaseFields();
      }));
    }
  }

  tabChange() {
    if (this.selectedElementType == 'tab') {
      this.getTabPromptForDataObjects();
      this.parentObjectChange();
    }
  }

  pageChange() {
    if (this.selectedElementType == 'page') {
      this.getPagePromptForDataObjects();
      this.parentObjectChange();
    }
  }

  controlChange() {
    if (this.selectedElementType == 'control') {
      this.getPromptForDataObjects();
      this.parentObjectChange();
      this.filterDatabaseFields();
      this.setSelectedStuPortCategory();
      this.setSelectedDocType();
      this.filterCSTFields();
      this.setSelectedCSTField();
      if (this.selectedControl && this.selectedControl.LinkedDBField) {
        const dbField = this.databaseFields.find(o => o.ID == this.selectedControl.LinkedDBField);
        if (dbField && dbField.ControlType == 'list' &&
          (this.selectedControl.ControlType == this.eFormService.controlTypes.dropdown
            || this.selectedControl.ControlType == this.eFormService.controlTypes.buttons
            || this.selectedControl.ControlType == this.eFormService.controlTypes.radioButtons)) {
          this.showChoicesLink = true;
        }
      }
    }
    if (this.selectedControl) {
      if (this.selectedControl.ControlType == 'dropdown' && !this.selectedControl.Width) {
        this.selectedControl.Width = '200px';
      }
      if (this.selectedControl.ControlType == 'date' && (!this.selectedControl.Width || this.selectedControl.Width == '100')) {
        this.selectedControl.Width = '125px';
      }
      if (!this.selectedControl.ConditionalAction) {
        this.selectedControl.ConditionalAction = 'show';
      }
    }
    this.setChooseLikeBackGround();
  }

  filterCSTFields() {
    if (this.selectedControl) {
      if (!this.selectedControl.CustomFieldControlTypeID) {
        this.selectedControl.CustomFieldControlTypeID = this.eFormDesignerService.convertEFormControlTypeToCustomFieldTypeID(this.selectedControl.ControlType);
      }
      this.availableCustomFields = this.eFormDesignerService.availableCSTFields.filter(o =>
          (o.ControlTypeID == this.selectedControl.CustomFieldControlTypeID
            || (this.selectedControl.ControlType == this.eFormService.controlTypes.note && o.ControlTypeID == CustomFieldControlTypeEnum.Textbox && o.DataTypeID == CustomFieldDataTypeEnum.AlphaNumeric) // textbox fields can use multi-line textboxes also
            || (this.selectedControl.ControlType == this.eFormService.controlTypes.textbox && o.ControlTypeID == CustomFieldControlTypeEnum.Time) // we currently use textbox fields for time data types
            || ((this.selectedControl.ControlType == this.eFormService.controlTypes.dropdown || this.selectedControl.ControlType == this.eFormService.controlTypes.buttons || this.selectedControl.ControlType == this.eFormService.controlTypes.radioButtons)
                && (o.ControlTypeID == CustomFieldControlTypeEnum.Dropdown || o.ControlTypeID == CustomFieldControlTypeEnum.Buttons || o.ControlTypeID == CustomFieldControlTypeEnum.RadioButtons)) // dropdowns/buttons/radio buttons are interchangeable
            || (this.selectedControl.ControlType == this.eFormService.controlTypes.date && (o.ControlTypeID == CustomFieldControlTypeEnum.Date || o.ControlTypeID == CustomFieldControlTypeEnum.DateTime))
          )
          && (this.isDevMode || !o.IsSysGen || !o.IsProcedureBased || o.ReadSPName) // if not in dev mode, procedure-based fields must have a read sp in order to be available for use
        ).sort((a, b) => a.DisplayName.localeCompare(b.DisplayName));
    }
  }

  setSelectedCSTField() {
    if (this.isCustomFieldsActive && this.selectedControl && !this.selectedControl.LinkedCSTFieldName && this.selectedControl.LinkedDBField > 0) {
      const field = this.availableCustomFields.find(o => o.DynamicPagesDataFiledsID == this.selectedControl.LinkedDBField);
      if (field) {
        this.selectedControl.LinkedCSTFieldName = field.FieldName;
      }
    }
  }

  getPromptForDataObjects() {
    if (this.selectedControl) {
      this.promptForDataObjects = this.eFormDesignerService.getPromptForDataObjects(this.selectedControl);
    }
  }

  getPagePromptForDataObjects() {
    if (this.selectedPage) {
      this.promptForDataObjects = this.eFormDesignerService.getPagePromptForDataObjects(this.selectedPage);
    }
  }

  getTabPromptForDataObjects() {
    if (this.selectedTab) {
      this.promptForDataObjects = this.eFormDesignerService.getTabPromptForDataObjects(this.selectedTab);
    }
  }

  getStudentPortfolioCategories() {
    this.studentPortfolioCategories = this.eFormDesignerService.studentPortfolioCategories;
    if (!this.studentPortfolioCategories || this.studentPortfolioCategories.length == 0) {
      this.subscriptions.push(this.lookupsService.getStudentPortfolioCategoryLookup().subscribe(result => {
        this.studentPortfolioCategories = result;
        this.eFormDesignerService.studentPortfolioCategories = result;
        this.setSelectedStuPortCategory();
      }));
    }
    else {
      this.setSelectedStuPortCategory();
    }
  }

  setSelectedStuPortCategory() {
    if (this.studentPortfolioCategories && this.selectedControl && this.selectedControl.StuPortCategoryId) {
      this.selectedStuPortCategory = this.studentPortfolioCategories.find(o => o.Id == this.selectedControl.StuPortCategoryId.toString());
    }
    else {
      this.selectedStuPortCategory = null;
    }
  }

  getDocumentTypes() {
    this.documentTypes = this.eFormDesignerService.documentTypes;
    if (!this.documentTypes || this.documentTypes.length == 0) {
      this.subscriptions.push(this.lookupsService.getDocumentTypeLookup().subscribe(result => {
        this.documentTypes = result;
        this.eFormDesignerService.documentTypes = result;
        this.setSelectedDocType();
      }));
    }
    else {
      this.setSelectedDocType();
    }
  }

  setSelectedDocType() {
    if (this.documentTypes && this.selectedControl && this.selectedControl.FormDocTypeId) {
      this.selectedDocType = this.documentTypes.find(o => o.Id == this.selectedControl.FormDocTypeId.toString());
    }
    else {
      this.selectedDocType = null;
    }
  }

  tabNameChanged() {
    this.eFormDesignerService.observableTabNameChanged.next(true);
  }

  parentObjectChange() {
    this.conditions = [];
    let parentObjId: number;
    if (this.selectedElementType == 'control' && this.selectedControl) {
      parentObjId = this.selectedControl.ParentObjectId;
    }
    else if (this.selectedElementType == 'page' && this.selectedPage) {
      parentObjId = this.selectedPage.ParentObjectId;
    }
    else if (this.selectedElementType == 'tab' && this.selectedTab) {
      parentObjId = this.selectedTab.ParentObjectId;
    }
    const selectedParentObject = this.eFormDesignerService.masterControlList.find(o => o.Id == parentObjId);
    if (selectedParentObject) {
      if (selectedParentObject.ControlType == this.eFormService.controlTypes.checkbox || selectedParentObject.ControlType == this.eFormService.controlTypes.checkboxWithTextbox) {
        const checkboxOptions: Lookup[] = [];
        const trueOption = new Lookup();
        trueOption.Code = 'true';
        trueOption.CodeDescription = 'Checked';
        checkboxOptions.push(trueOption);
        const falseOption = new Lookup();
        falseOption.Code = 'false';
        falseOption.CodeDescription = 'Not Checked';
        checkboxOptions.push(falseOption);
        this.conditions = checkboxOptions;
      }
      else if (selectedParentObject.ControlType == this.eFormService.controlTypes.textbox || selectedParentObject.ControlType == this.eFormService.controlTypes.note) {
        const textboxOptions: Lookup[] = [];
        const notBlank = new Lookup();
        notBlank.Code = 'notBlank';
        notBlank.CodeDescription = 'Not Blank';
        textboxOptions.push(notBlank);
        const blank = new Lookup();
        blank.Code = 'blank';
        blank.CodeDescription = 'Blank';
        textboxOptions.push(blank);
        this.conditions = textboxOptions;
      }
      else if (selectedParentObject.CustomField && selectedParentObject.CustomFieldName) {
        this.getCustomFieldMetaData(selectedParentObject.CustomFieldName);
      }
      else if (selectedParentObject.DropdownOptions) {
        this.conditions = selectedParentObject.DropdownOptions;
      }

      this.setSelectedCondition();
    }
  }

  setSelectedCondition() {
    if (this.conditions && this.conditions.length > 0) {
      if (this.selectedElementType == 'control' && this.selectedControl
        && this.selectedControl.Condition
        && this.conditions.find(o => o.Code == this.selectedControl.Condition) == null) {
        this.selectedControl.Condition = this.conditions[0].Code;
      }
      else if (this.selectedElementType == 'page' && this.selectedPage
        && this.selectedPage.Condition
        && this.conditions.find(o => o.Code == this.selectedPage.Condition) == null) {
        this.selectedPage.Condition = this.conditions[0].Code;
      }
      else if (this.selectedElementType == 'tab' && this.selectedTab
        && this.selectedTab.Condition
        && this.conditions.find(o => o.Code == this.selectedTab.Condition) == null) {
        this.selectedTab.Condition = this.conditions[0].Code;
      }
    }
  }

  getCustomFieldMetaData(fieldName: string) {
    let field = this.customizationFrameworkService.customDataFields.find(o => o.FieldName == fieldName);
    if (field && field.IsDataDef) {
      if (field.DataDef) {
        this.updateCustomFieldConditions(field.DataDef, field.UseDataDefCode);
      }
      else {
        this.getCustomFieldDataDef(field);
      }
    }
    else if (!field) {
      this.customizationFrameworkService.getCustomDataFieldByFieldName(fieldName).pipe(take(1)).subscribe(f => {
        field = f;
        if (!this.customizationFrameworkService.customDataFields.find(o => o.FieldName == f.FieldName)) {
          this.customizationFrameworkService.customDataFields.push(f);
        }
        this.getCustomFieldMetaData(fieldName);
      });
    }
  }

  getCustomFieldDataDef(field: CSTField) {
    this.customizationFrameworkService.getDataDefinitionListByEnum(field.LookupENUM).pipe(take(1)).subscribe(dataDefinitionList => {
      this.updateCustomFieldConditions(dataDefinitionList, field.UseDataDefCode);
    });
  }

  updateCustomFieldConditions(dataDef: DataDefinitionList, useDataDefCode: boolean) {
    this.conditions = [];
    dataDef.DataDefinitions.forEach(def => {
      const lookup = new Lookup();
      lookup.Id = def.Id.toString();
      lookup.Code = useDataDefCode ? def.Code : def.Id.toString();
      lookup.CodeDesc = (dataDef.CodeNotRequired ? '' : (def.Code ? def.Code : '') + ' - ') + (def.Description ? def.Description : '');
      lookup.CodeDescription = lookup.CodeDesc;
      this.conditions.push(lookup);
    });
    this.setSelectedCondition();
  }

  displayMergeFields() {
    const mergeFieldDialog = this.dialog.open(MergeFieldDialogComponent, {
      height: '80vh',
      minWidth: '200px',
      hasBackdrop: false,
      disableClose: true
    });
  }

  mergeFieldClicked(mergeField: EFormMergeField) {
    if (mergeField) {
      const mergeTag = mergeField.FieldName;
      if (this.quill || this.selectedControl.ControlType != this.eFormService.controlTypes.text) {
        if (mergeField.ID == 1) { // value from another control
          const valueFromAnotherFieldDialog = this.dialog.open(ValueFromAnotherFieldDialogComponent, {
            disableClose: true
          });
          this.subscriptions.push(valueFromAnotherFieldDialog.afterClosed().subscribe(tag => {
            if (tag) {
              this.insertMergeTag(tag);
            }
          }));
        }
        else {
          this.insertMergeTag(mergeTag);
        }
      }
    }
  }

  insertMergeTag(tag: string) {
    if (this.selectedControl.ControlType == this.eFormService.controlTypes.text) {
      const range = this.quill.quillEditor.getSelection(true);
      if (range.length > 0) {
        this.quill.quillEditor.deleteText(range.index, range.length, 'user');
      }
      this.quill.quillEditor.insertText(range.index, tag, 'user');
    }
    else {
      this.selectedControl.Label = [this.selectedControl.Label.slice(0, this.cursorPosition), tag, this.selectedControl.Label.slice(this.cursorPosition)].join('');
    }
  }

  textProvidedOnInstanceChanged() {
    if (!this.selectedControl.TextProvidedOnInstance) {
      this.selectedControl.Instructions = '';
    }
    else {
      this.selectedControl.Value = '';
      if (this.selectedControl.ControlType == this.eFormService.controlTypes.linkToFile) {
        this.selectedControl.AttachmentId = null;
        this.selectedControl.Attachment = new EFormAttachment();
      }
    }
  }

  choicesClick() {
    const choicesDialog = this.dialog.open(EFormChoicesDialogComponent, {
      height: '80vh',
      disableClose: true,
      data: {
        selectedControl: this.selectedControl,
        showCriticalCondition: this.config.IsSurvey
      }
    });
    this.subscriptions.push(choicesDialog.afterClosed().subscribe((editedControl: EFormControl) => {
      if (editedControl) {
        this.selectedControl.DropdownOptions = editedControl.DropdownOptions;
        this.selectedControl.Value = editedControl.Value;
        if (this.selectedControl.ControlType == this.eFormService.controlTypes.radioButtons) {
          this.eFormDesignerService.observableRadioOptionsChanged.next(true);
        }
        this.eFormDesignerService.updateConditionalControls(this.selectedControl);
      }
      // ########
      this.setChooseLikeBackGround();
      // ########
    }));
  }

  filterDatabaseFields() {
    this.databaseFields = [];
    if (this.selectedControl) {
      if (this.selectedControl.ControlType == this.eFormService.controlTypes.buttons || this.selectedControl.ControlType == this.eFormService.controlTypes.radioButtons || this.selectedControl.ControlType == this.eFormService.controlTypes.dropdown) {
        this.databaseFields = this.allDBFields.filter(o => o.ControlType == 'list');
      }
      else if (this.selectedControl.ControlType == this.eFormService.controlTypes.textbox || this.selectedControl.ControlType == this.eFormService.controlTypes.note) {
        this.databaseFields = this.allDBFields.filter(o => o.ControlType == 'textbox');
      }
      else if (this.selectedControl.ControlType == this.eFormService.controlTypes.date) {
        this.databaseFields = this.allDBFields.filter(o => o.ControlType == 'date');
      }
      this.databaseFields = _.sortBy(this.databaseFields, o => o.FieldName.toLowerCase());
    }
  }

  locationToSaveChange() {
    if (!this.isCustomFieldsActive) {
      this.showChoicesLink = false;
      this.selectedControl.LinkedCSTFieldName = null;  // we are saving to the old UD fields, not to CST fields
      if (this.selectedControl.LinkedDBField > 0) {
        const dbField = this.databaseFields.find(o => o.ID == this.selectedControl.LinkedDBField);
        if (dbField && dbField.ControlType == 'list') {
          this.selectedControl.DropdownOptions = [];
          this.subscriptions.push(this.eFormService.getEFormDatabaseFieldOptions(this.selectedControl.LinkedDBField, this.yearService.defaultYear.Id).subscribe(options => {
            this.selectedControl.DropdownOptions = options;
            if (this.selectedControl.ControlType == this.eFormService.controlTypes.dropdown) {
              this.selectedControl.DropdownOptions = options;
            }
            else {
              this.selectedControl.DropdownOptions = options.filter(o => o.CodeDescription.trim() != '');
            }
            if (this.selectedControl.ControlType == this.eFormService.controlTypes.radioButtons) {
              this.eFormDesignerService.observableRadioOptionsChanged.next(true);
            }
            this.showChoicesLink = true;
          }));
        }
        else {
          if (this.selectedControl.ControlType == this.eFormService.controlTypes.dropdown
            || this.selectedControl.ControlType == this.eFormService.controlTypes.buttons
            || this.selectedControl.ControlType == this.eFormService.controlTypes.radioButtons) {
            this.showChoicesLink = true;
          }
        }
      }
      else {
        this.selectedControl.DropdownOptions = [];
        if (this.selectedControl.ControlType == this.eFormService.controlTypes.radioButtons) {
          this.eFormDesignerService.observableRadioOptionsChanged.next(true);
        }
      }
      this.selectedControl.Value = '';
      this.setChooseLikeBackGround();
    }
  }



  locationToSaveCSTChange() {
    if (this.isCustomFieldsActive) {
      this.showChoicesLink = false;
      this.selectedControl.LinkedDBField = -1; // we are saving to CST fields, not to the old UD fields
      if (this.isCustomFieldsActive && this.selectedControl.LinkedCSTFieldName) {
        const cstField = this.availableCustomFields.find(o => o.FieldName == this.selectedControl.LinkedCSTFieldName);
        if (cstField && cstField.LookupENUM && cstField.IsDataDef) {
          this.selectedControl.DropdownOptions = [];
          this.customizationFrameworkService.getDataDefinition(cstField.LookupENUM, this.yearService.defaultYear.Id, this.yearService.defaultYear.SiteYearId, null).pipe(take(1)).subscribe(options => {
            options.forEach(opt => {
              const lookup = new Lookup();
              lookup.Id = opt.Id.toString();
              lookup.Code = opt.Id.toString();
              lookup.CodeDescription = opt.Description;
              lookup.Default = opt.IsDefault;
              this.selectedControl.DropdownOptions.push(lookup);
            });
            if (this.selectedControl.ControlType != this.eFormService.controlTypes.dropdown) {
              this.selectedControl.DropdownOptions = this.selectedControl.DropdownOptions.filter(o => o.CodeDescription.trim() != '');
            }
            if (this.selectedControl.ControlType == this.eFormService.controlTypes.radioButtons) {
              this.eFormDesignerService.observableRadioOptionsChanged.next(true);
            }
            this.showChoicesLink = true;
          });
        }
        else {
          if (this.selectedControl.ControlType == this.eFormService.controlTypes.dropdown
            || this.selectedControl.ControlType == this.eFormService.controlTypes.buttons
            || this.selectedControl.ControlType == this.eFormService.controlTypes.radioButtons) {
            this.showChoicesLink = true;
          }
        }
      }
      else {
        this.selectedControl.DropdownOptions = [];
        if (this.selectedControl.ControlType == this.eFormService.controlTypes.radioButtons) {
          this.eFormDesignerService.observableRadioOptionsChanged.next(true);
        }
      }
      this.selectedControl.Value = '';
      this.setChooseLikeBackGround();
    }
  }

  setChooseLikeBackGround() {
    setTimeout(() => {
      if (this.selectedControl && this.selectedControl.DropdownOptions) {
        const objValue = this.selectedControl.DropdownOptions.length ? (this.selectedControl.DropdownOptions.filter(o => o.CodeDescription != '' && o.CodeDescription != null)[0]) : null;
        this.isCodeDescriptionValue = false;
        if (objValue) {
          this.isCodeDescriptionValue = true;
        }
      }
      else {
        this.isCodeDescriptionValue = false;
      }
    }, 1010);
  }

  fileChanged(name: string) {
    if (!this.selectedControl.Label) {
      this.selectedControl.Label = name;
    }
    this.selectedControl.Attachment.Name = name;
    this.selectedControl.AttachmentId = null;
  }

  labelChanged(label: string) {
    if (this.selectedControl.ControlType == this.eFormService.controlTypes.image || this.selectedControl.ControlType == this.eFormService.controlTypes.linkToFile) {
      if (this.selectedControl.Attachment) {
        this.selectedControl.Attachment.Name = label;
      }
    }
  }

  getCaretPosition(inputElement) {
    if (inputElement.selectionStart || inputElement.selectionStart == '0') {
      this.cursorPosition = inputElement.selectionStart;
    }
  }

  stuPortCategoryChange() {
    this.selectedControl.StuPortCategoryId = null;
    if (this.selectedStuPortCategory) {
      const stringId = this.selectedStuPortCategory.Id;
      if (Number(stringId)) {
        this.selectedControl.StuPortCategoryId = parseInt(stringId, 10);
      }
    }
  }

  docTypeChange() {
    this.selectedControl.FormDocTypeId = null;
    if (this.selectedDocType) {
      const stringId = this.selectedDocType.Id;
      if (Number(stringId)) {
        this.selectedControl.FormDocTypeId = parseInt(stringId, 10);
      }
    }
  }

  storeLocationChange(location: string) {
    if (location != 'student portfolio') {
      this.selectedControl.StuPortCategoryId = null;
      this.selectedStuPortCategory = null;
    }
    if (location != 'student digital content') {
      this.selectedControl.FormDocTypeId = null;
      this.selectedDocType = null;
    }
  }

  customFieldSelectChange() {
    if (this.selectedControl.CustomFieldName) {
      const customField = this.availableCustomFields.find(control => control.FieldName == this.selectedControl.CustomFieldName);
      if (customField) {
        if (!this.selectedControl.Label) {
          this.selectedControl.Label = customField.DisplayName;
        }
        if (customField.IsRequired) {
          this.selectedControl.IsRequired = true;
        }
        if (customField.ControlTypeID == CustomFieldControlTypeEnum.Time || customField.ControlTypeID == CustomFieldControlTypeEnum.DateTime) {
          this.selectedControl.CustomFieldControlTypeID = customField.ControlTypeID;
        }
      }
    }
  }

  isCustomFieldRequired(fieldName: string) {
    const c = this.availableCustomFields.find(o => o.FieldName == fieldName);
    return c && c.IsRequired;
  }

  ngOnDestroy(): void {

  }

  colWidthChange() {
    if (this.selectedColumn && !this.selectedColumn.FixedWidth) {
      this.selectedColumn.Width = null;
    }
  }

}
